(() => {
  if (window.HolyQuickLauncher) return;
  window.HolyQuickLauncher = true;
  let pendingButton, timer;
  const feedback = () => document.querySelector('[data-hs-quick-feedback]');
  function clearPending() {
    clearTimeout(timer);
    pendingButton?.removeAttribute('aria-busy');
    pendingButton = null;
    if (feedback()) feedback().hidden = true;
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-hs-quick]');
    if (!button) return;
    event.preventDefault();
    if (window.BulkPurchase?.openModal) {
      clearPending();
      window.BulkPurchase.openModal();
      return;
    }
    if (pendingButton) return;
    pendingButton = button;
    button.setAttribute('aria-busy', 'true');
    if (feedback()) {
      feedback().textContent = 'Carregando a compra rápida…';
      feedback().hidden = false;
    }
    timer = setTimeout(() => {
      clearPending();
      if (feedback()) {
        feedback().textContent = 'A compra rápida ainda está carregando. Toque no raio para tentar novamente.';
        feedback().hidden = false;
      }
    }, 12000);
  });
  document.addEventListener('hs:quick-ready', () => {
    if (!pendingButton) return;
    clearPending();
    window.BulkPurchase.openModal();
  });
})();
